export default "__VITE_ASSET__LyeIRloY__"